import { Component, Input, OnDestroy, OnInit } from "@angular/core";

let PDFViewerApplication = window["PDFViewerApplication"];
let webViewerLoad = window["webViewerLoad"];

@Component({
  selector: "file-picker-viewer",
  templateUrl: "../../../../../../insa-report/web/viewer.html",
})
export class FilePickerViewerComponent implements OnInit, OnDestroy {
  @Input() pdfContent;

  public reportTypes = [];
  reportIsLoaded;

  ngOnInit() {
    if (this.pdfContent) {
      this.renderReport(this.pdfContent.split(",")[1]);
    }
  }

  renderReport(report: string, forcePDFviewerReinit: boolean = false) {
    var b64Array = new Uint8Array(this.base64_to_uint8array(report));
    webViewerLoad(b64Array, true);
    this.reportIsLoaded = true;
  }

  base64_to_uint8array(s) {
    var byteChars = atob(s);
    var l = byteChars.length;
    var byteNumbers = new Array(l);

    for (var i = 0; i < l; i++) {
      byteNumbers[i] = byteChars.charCodeAt(i);
    }
    return new Uint8Array(byteNumbers);
  }

  ngOnDestroy() {
    PDFViewerApplication.close();
  }
}



// WEBPACK FOOTER //
// ./app/insa-components/insa-generic-form/generic-editor/components/fields/file-picker/FilePickerViewer.component.ts